import { z } from 'zod';
import { storageSchemaMap } from './schemas';

export type ZodSchema<T> = z.ZodType<T>;

export const STORAGE_MIGRATION_VERSION = 1;

const MIGRATION_KEY = 'bg2_migration_version';

export function validateStorage<T>(
  key: string,
  data: unknown,
  schema: ZodSchema<T>,
  fallback: T,
): T {
  const result = schema.safeParse(data);
  if (result.success) {
    return result.data;
  }
  console.warn(`[validation] Key "${key}" failed validation, using fallback:`, result.error.issues);
  return fallback;
}

export function validateStorageByKey<T>(key: string, data: unknown, fallback: T): T {
  const schema = storageSchemaMap[key];
  if (!schema) return (data ?? fallback) as T;
  return validateStorage(key, data, schema as ZodSchema<T>, fallback);
}

export function getMigrationVersion(): number {
  try {
    const raw = localStorage.getItem(MIGRATION_KEY);
    return raw ? parseInt(raw, 10) : 0;
  } catch {
    return 0;
  }
}

export function setMigrationVersion(version: number = STORAGE_MIGRATION_VERSION): void {
  try {
    localStorage.setItem(MIGRATION_KEY, String(version));
  } catch { /* ignore */ }
}

export function needsMigration(): boolean {
  return getMigrationVersion() < STORAGE_MIGRATION_VERSION;
}